<template>
  <panel title="生产统计" :infoContents="infoContents" class="mgb10">
    <vxe-table
      :data="records"
      border
      size="small"
      :loading="loading"
      class="border-inner-top"
      auto-resize
      highlight-hover-row
      :scroll-y="{ enabled: false }"
    >
      <vxe-table-column
        field="acceptMonthQty"
        title="本月接单量"
      ></vxe-table-column>
      <vxe-table-column
        field="finishMonthQty"
        title="本月完成量"
      ></vxe-table-column>
      <vxe-table-column
        field="processingQty"
        title="目前在产量"
      ></vxe-table-column>
      <vxe-table-column field="reworkQty" title="本月返工量"></vxe-table-column>
      <vxe-table-column
        field="acceptYearQty"
        title="本年接单量"
      ></vxe-table-column>
      <vxe-table-column
        field="finishYearQty"
        title="本年完成量"
      ></vxe-table-column>
    </vxe-table>
  </panel>
</template>

<script>
import OrderMes from "@/api/orderMes.js";

export default {
  data() {
    return {
      loading: false,
      records: [],

      infoContents: [
        "接单量：以生产订单创建日期统计 订单数量和",
        "完成量：以尾查日期统计 已尾查量和",
        "目前在产量：目前状态是新的和生产中的数量和（去除以暂停生产的工单）",
        "本月返工量：以返工单的创建日期统计 返工单的数量和",
      ],
    };
  },
  created() {
    const self = this;
    self.loading = true;
    OrderMes.workbenchQtyCount().then(function (res) {
      if (res.data.code === 200) {
        self.records = [res.data.entity];
      } else {
        self.sysError();
      }
      self.loading = false;
    });
  },
};
</script>